import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'

export default class FlatpickrController extends Controller {
  connect() {
    flatpickr.localize(French);

    flatpickr(this.element, {
      dateFormat: "d/m/Y",
      disableMobile: true,
      allowInput: true,
      parseDate: (datestr, format) => {
        const parsed = flatpickr.parseDate(datestr, format);

        if (parsed === undefined) {
          this.element.classList.add('border-danger');
        }
        return parsed;
      },
    });
  }
}
